import React, { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";

import Rating from "./rating";
import SpinLoading from "../../shared/spin_loading";

const chunkArray = (myArray, chunk_size) => {
  let index = 0;
  const arrayLength = myArray.length;
  let tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
    let myChunk = myArray.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }
  return tempArray;
};

const RatingsSection = props => {
  const [ratingsList, setRatingsList] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [productAvg, setProductAvg] = useState(null);
  const [hotelAvg, setHotelAvg] = useState(null);
  const [hotelRatingCount, setHotelRatingCount] = useState(null);
  const [productRatingCount, setProductRatingCount] = useState(null);

  const loadRatings = () => {
    axios
      .get("/api/ratings", {
        params: {
          hotel_id: props.hotel_id,
          product_id: props.product_id,
        },
      })
      .then((response) => {
        setRatingsList(response.data.ratings);
        setHotelAvg(response.data.hotel_avg_rating);
        setHotelRatingCount(response.data.hotel_reviews_count);
        setProductAvg(response.data.product_avg_rating);
        setProductRatingCount(response.data.product_reviews_count);
        setIsLoad(true);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  return (
    <VisibilitySensor
      scrollCheck={true}
      partialVisibility={true}
      onChange={(visible) => {
        if (visible && !isLoad) {
          loadRatings();
        }
      }}
    >
      <React.Fragment>
        <SpinLoading show={!isLoad} />
        <div className="text-center mb-4">
          {hotelAvg && (
            <h3 className="text-success">
              <i className="fa fa-hotel mr-2" />
              {hotelAvg}/6
              {hotelRatingCount && (
                <small> ({hotelRatingCount} hodnocení)</small>
              )}
            </h3>
          )}
          {productAvg && (
            <h3 className="text-success">
              <i className="far fa-smile mr-2" />
              {productAvg}/6
              {productRatingCount && (
                <small> ({productRatingCount} hodnocení)</small>
              )}
            </h3>
          )}
        </div>
        {chunkArray(ratingsList, 4).map((slice, i) => (
          <div key={i} className="row mb-md-4 mb-sm-0">
            {slice.map((rating, j) => (
              <div
                key={i + j}
                className="col-auto col-6 col-sm-6 col-md-3 col-lg-3"
              >
                <Rating
                  key={rating.id}
                  id={rating.id}
                  name={rating.name}
                  value={rating.value}
                  imageUrl={rating.image_url}
                />
              </div>
            ))}
          </div>
        ))}
      </React.Fragment>
    </VisibilitySensor>
  );
};

RatingsSection.propTypes = {
  hotel_id: PropTypes.number,
  product_id: PropTypes.number
};

export default RatingsSection;
